import { BaseModel } from "./base"
import { JsonProperty } from "../requests/jsonparser";

export class NewsProvider extends BaseModel {

    @JsonProperty({ type: 'false' })
    ISHELPERMODEL: string;
    @JsonProperty({ type: 'NewsProvider' })
    MODELNAME: string;

    @JsonProperty({ type: 'string' })
    id: string;

    @JsonProperty({ type: 'string' })
    title: string

    @JsonProperty({ type: 'string' })
    image_url: string

    @JsonProperty({ type: 'string?' })
    banner_image_url?: string

    @JsonProperty({ type: 'string?' })
    tile_color?: string

    @JsonProperty({ type: 'number' })
    order: number

    @JsonProperty({ type: 'boolean?' })
    is_followed?: boolean

}



// WEBPACK FOOTER //
// ./src/api/src/models/news_provider.ts